var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: 20,
    width: 20,
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,1H10C6.1,1,3,4.1,3,8s3.1,7,7,7h12c3.9,0,7-3.1,7-7S25.9,1,22,1z M22,12c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4 S24.2,12,22,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17H10c-3.9,0-7,3.1-7,7s3.1,7,7,7h12c3.9,0,7-3.1,7-7S25.9,17,22,17z M10,28c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4 S12.2,28,10,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.c4d70d857958b631b29384e829ec9008.svg";
export { ForwardRef as ReactComponent };